// N11 (05/10/2026) — "Kịch bản học trên bot — chỉ chạy": bundle cũ dạy/học trên bot (không có sơ đồ, KHÔNG dịch ngược được — docs/phuong-an-gom-
// loi-chay.md mục 3). Thay cho Kho kịch bản + Phát lệnh mới của Boss thường:
//   theHocTrenBot()      — phần cuối trang #/kich-ban: hợp của kho (GET /api/bundles, bản mới nhất mỗi tên) và tên bot báo về (bot.bundles), BỎ mọi
//                          tên kịch bản sơ đồ kb-… (đã có ở danh sách chính → hết "cùng kịch bản hiện 2 nơi"). Ẩn khi rỗng.
//   renderKichBanTuBot() — trang #/kich-ban/tu-bot/:ten: đầu trang, Chạy (khung phat-lenh-khung.ts rút gọn), Cài xuống bot, Các bản, Tần suất,
//                          Viết lại thành sơ đồ bằng AI (tạo kịch bản sơ đồ MỚI). Không có API mới — dùng /api/bundles*, /api/jobs*, /api/schedules.
// Mọi chữ dựng bằng textContent (tên/mô tả có ký tự đặc biệt hiện dạng chữ).
import { api, errMsg } from "../api";
import { busy, clear, confirmBox, gen, h, toast } from "../dom";
import { fmtTime } from "../format";
import { isSuper, loadBots, sortBots } from "../store";
import type { Bot } from "../types";
import { locBotIds } from "../chuyen-huong";
import { laMaKbSoDo } from "../ten-kb";
import { countSteps, detail, pushAll, pushDialog, type KhoBundle, type KhoBundleFull } from "./bundles";
import { taoKhungPhatLenh } from "./phat-lenh-khung";
import type { Schedule } from "./notify";

/** Một kịch bản học trên bot trong danh sách (khoá theo chủ + tên). */
export interface DongHocTrenBot { ten: string; ownerId: string | null; kho: KhoBundle | null; soBot: number }

/** Gộp kho + tên bot báo về, bỏ kb-…; sắp theo tên (tiếng Việt). Hàm thuần (không DOM). */
export function gopHocTrenBot(kho: KhoBundle[], bots: Bot[], ownerId?: string | null): DongHocTrenBot[] {
  const m = new Map<string, DongHocTrenBot>();
  const khoa = (o: string | null, t: string) => `${o ?? ""}\u0000${t}`;
  for (const k of kho) {
    if (laMaKbSoDo(k.name) || (ownerId && k.ownerId !== ownerId)) continue;
    const cu = m.get(khoa(k.ownerId, k.name));
    if (!cu || (cu.kho && cu.kho.version < k.version)) m.set(khoa(k.ownerId, k.name), { ten: k.name, ownerId: k.ownerId, kho: k, soBot: 0 });
  }
  for (const b of bots) {
    if (ownerId && b.ownerId !== ownerId) continue;
    for (const r of b.bundles) {
      if (laMaKbSoDo(r.name)) continue;
      const k = khoa(b.ownerId, r.name);
      const d = m.get(k) ?? { ten: r.name, ownerId: b.ownerId, kho: null, soBot: 0 };
      d.soBot++;
      m.set(k, d);
    }
  }
  return [...m.values()].sort((a, b) => a.ten.localeCompare(b.ten, "vi"));
}

const duongTuBot = (ten: string, botIds: string[] = []): string =>
  `#/kich-ban/tu-bot/${encodeURIComponent(ten)}${botIds.length ? `?botIds=${botIds.join(",")}` : ""}`;

/** Phần "Kịch bản học trên bot — chỉ chạy" cuối trang Kịch bản. Ẩn khi rỗng; lỗi tải → câu lỗi nhỏ (trang vẫn dùng được). */
export function theHocTrenBot(opts: { ownerId?: string | null; botIds?: string[]; alive: () => boolean; xong?: (el: HTMLElement, soDong: number) => void }): HTMLElement {
  const ds = h("div", { "data-testid": "kb-htb-ds" });
  const the = h("section", { class: "card", id: "hoc-tren-bot", "data-testid": "kb-hoc-tren-bot", hidden: true },
    h("h3", {}, "Kịch bản học trên bot — chỉ chạy"),
    h("p", { class: "small muted" }, "Kịch bản dạy/học trực tiếp trên bot từ trước, không có sơ đồ: chạy được, cài xuống bot khác được, nhưng không sửa bước bằng sơ đồ."),
    ds);
  void (async () => {
    let dong: DongHocTrenBot[];
    try {
      const [kho, bots] = await Promise.all([api<KhoBundle[]>("GET", "/api/bundles"), loadBots().catch(() => [] as Bot[])]);
      dong = gopHocTrenBot(kho, bots, opts.ownerId ?? null);
    } catch (e) {
      if (!opts.alive()) return;
      the.hidden = false;
      ds.append(h("p", { class: "err small", "data-testid": "kb-htb-loi" }, `Không tải được kịch bản học trên bot: ${errMsg(e)}`));
      opts.xong?.(the, 0);
      return;
    }
    if (!opts.alive()) return;
    the.hidden = !dong.length;
    for (const d of dong) {
      ds.append(h("a", { class: "kb-dong kb-htb-dong", href: duongTuBot(d.ten, opts.botIds), "data-testid": "kb-htb-dong", dataset: { name: d.ten } },
        h("span", { class: "tag", title: "Kịch bản học trên bot: chỉ chạy, không sửa bằng sơ đồ" }, "chỉ chạy"),
        h("span", { class: "kb-dong-ten" }, d.ten),
        h("span", { class: "kb-dong-phu small muted" },
          [d.kho?.description ? `${d.kho.description} · ` : "", `có trên ${d.soBot} bot · `, d.kho ? `đã lưu v${d.kho.version}` : "chưa lưu — chỉ có trên bot", isSuper() && d.ownerId ? ` · chủ ${d.ownerId}` : ""].join(""))));
    }
    opts.xong?.(the, dong.length);
  })();
  return the;
}

// =============== trang một kịch bản học trên bot ===============
export async function renderKichBanTuBot(root: HTMLElement, params: Record<string, string>, query: URLSearchParams): Promise<() => void> {
  const alive = gen("kich-ban-tu-bot");
  const ten = params.ten ?? "";
  const quay = h("p", { class: "small" }, h("a", { href: "#/kich-ban?xem=hoc-tren-bot", title: "Về danh sách Kịch bản", "data-testid": "htb-quay-lai" }, "← Kịch bản"));
  const tieuDe = h("h1", { class: "wrap", "data-testid": "htb-ten" }, ten);
  root.append(quay, tieuDe);
  const dangTai = h("p", { class: "muted" }, "Đang tải…");
  root.append(dangTai);
  let kho: KhoBundle[] = [];
  let bots: Bot[] = [];
  try {
    [kho, bots] = await Promise.all([api<KhoBundle[]>("GET", "/api/bundles"), loadBots(true).then(sortBots)]);
  } catch (e) {
    if (!alive()) return () => {};
    dangTai.replaceWith(h("div", { class: "err-box", "data-testid": "page-error" }, "Không tải được kịch bản: ", errMsg(e)));
    return () => {};
  }
  if (!alive()) return () => {};
  dangTai.remove();
  const chuMuon = isSuper() ? query.get("ownerId") : null;
  const cungTen = kho.filter((k) => k.name === ten && (!chuMuon || k.ownerId === chuMuon)).sort((a, b) => b.version - a.version);
  const banKho = cungTen[0] ?? null;
  const chu = banKho?.ownerId ?? chuMuon ?? bots.find((b) => b.bundles.some((r) => r.name === ten))?.ownerId ?? null;
  const botCuaChu = chu ? bots.filter((b) => b.ownerId === chu) : bots;
  const soBotCo = botCuaChu.filter((b) => b.bundles.some((r) => r.name === ten)).length;
  if (!ten || laMaKbSoDo(ten) || (!banKho && !soBotCo)) {
    root.append(h("div", { class: "card empty", "data-testid": "htb-khong-thay" },
      h("p", {}, laMaKbSoDo(ten) ? "Đây là mã của một kịch bản sơ đồ — mở nó ở danh sách Kịch bản." : "Không tìm thấy kịch bản học trên bot này."),
      h("p", {}, h("a", { href: "#/kich-ban", title: "Về danh sách Kịch bản" }, "Về danh sách Kịch bản"))));
    return () => {};
  }

  // ---- 1. Đầu trang
  const dau = h("div", { class: "card", "data-testid": "htb-dau" },
    banKho?.description ? h("p", { class: "wrap", "data-testid": "htb-mo-ta" }, banKho.description) : h("p", { class: "muted small" }, "Không có mô tả."),
    h("p", { class: "small", "data-testid": "htb-tom-tat" }, [
      `Có trên ${soBotCo} bot`,
      banKho ? ` · đã lưu v${banKho.version} (${fmtTime(banKho.createdAt)})` : " · chưa lưu vào Kịch bản — chỉ có trên bot",
      banKho ? ` · ${Object.keys(banKho.params ?? {}).length} tham số` : "",
    ].join("")),
    h("p", { class: "small muted" }, "Kịch bản này học trên bot, không có sơ đồ — muốn sửa bước hãy dùng “Viết lại thành sơ đồ bằng AI” ở cuối trang."),
    h("p", { class: "small" }, h("a", { href: `#/history?bundleName=${encodeURIComponent(ten)}`, title: "Mở Lịch sử chạy chỉ gồm các lần chạy kịch bản này", "data-testid": "htb-lich-su" }, "Lịch sử chạy của kịch bản này")));
  const soBuoc = h("span", { "data-testid": "htb-so-buoc" });
  if (banKho) {
    dau.querySelector('[data-testid="htb-tom-tat"]')!.append(" · ", soBuoc);
    void api<KhoBundleFull>("GET", `/api/bundles/${encodeURIComponent(banKho.id)}`)
      .then((full) => { if (alive()) soBuoc.textContent = `${countSteps(full.json?.steps)} bước`; })
      .catch(() => { /* không có số bước vẫn chạy được */ });
  }
  root.append(dau);

  // ---- 2. Chạy (khung form dùng chung, cấu hình rút gọn)
  const chonSan = locBotIds(query.get("botIds")).filter((id) => botCuaChu.some((b) => b.id === id));
  const theChay = h("div", { class: "card", "data-testid": "htb-chay" }, h("h3", {}, "Chạy"));
  root.append(theChay);
  const khung = taoKhungPhatLenh(theChay, {
    bots: botCuaChu, chonSan, dayDu: false, alive, tenCoDinh: ten, kho: banKho,
    quayLai: { href: "#/kich-ban?xem=hoc-tren-bot", text: "Quay lại", title: "Về danh sách Kịch bản (chưa chạy gì)" },
  });
  khung.batDau();

  // ---- 3. Cài xuống bot
  const theCai = h("div", { class: "card", "data-testid": "htb-cai" }, h("h3", {}, "Cài xuống bot"));
  if (banKho) {
    const caiAll = h("button", { type: "button", title: "Cài bản này xuống MỌI bot của tài khoản (bỏ bot đã có đúng bản; bot ngoại tuyến/bận xếp hàng)", "data-testid": "htb-cai-tat-ca" }, "Cài cho tất cả bot");
    caiAll.addEventListener("click", () => void pushAll(banKho, caiAll));
    theCai.append(h("p", { class: "small muted" }, "Cài bản đã lưu xuống bot khác (giữ nguyên tên)."),
      h("div", { class: "row" }, h("button", { type: "button", class: "pri", title: "Chọn bot để cài bản này xuống; bot ngoại tuyến hoặc đang bận sẽ xếp hàng", "data-testid": "htb-cai-bot", onclick: () => void pushDialog(banKho) }, "Cài xuống bot…"), caiAll));
  } else {
    theCai.append(h("p", { class: "small", "data-testid": "htb-chua-luu" }, "Kịch bản chưa được lưu nên chưa cài sang bot khác được. Ở trang ",
      h("a", { href: "#/bots", title: "Về trang Bot" }, "Bot"), ", mở “Kịch bản của bot” trên thẻ một bot đang có kịch bản này (bot phải trực tuyến) và bấm ", h("b", {}, "Đưa vào Kịch bản"), "."));
  }
  root.append(theCai);

  // ---- 4. Các bản (bản cũ để cài lại khi bản mới hỏng)
  if (banKho) {
    const theBan = h("div", { class: "card", "data-testid": "htb-cac-ban" }, h("h3", {}, "Các bản"));
    const nutCt = h("button", { type: "button", class: "mini", title: "Xem mô tả, số bước, tham số và các bản khác", "data-testid": "htb-chi-tiet" }, "Chi tiết…");
    nutCt.addEventListener("click", () => void detail(banKho, nutCt));
    const bang = h("div", {}, h("p", { class: "muted small" }, "Đang tải các bản…"));
    theBan.append(bang, h("div", { class: "row" }, nutCt));
    root.append(theBan);
    void api<KhoBundle[]>("GET", "/api/bundles?all=1").then((all) => {
      if (!alive()) return;
      const ds = all.filter((x) => x.name === ten && x.ownerId === banKho.ownerId).sort((a, b) => b.version - a.version);
      clear(bang);
      bang.append(h("div", { class: "tbl htb-ban-tbl" }, h("table", {}, h("thead", {}, h("tr", {}, h("th", {}, "Bản"), h("th", {}, "Ngày"), h("th", {}))),
        h("tbody", {}, ...ds.map((o) => h("tr", { "data-testid": "htb-ban", dataset: { version: String(o.version) } },
          h("td", {}, `v${o.version}`, o.id === banKho.id ? h("span", { class: "tag ok", style: "margin-left:6px" }, "mới nhất") : null),
          h("td", { class: "nowrap" }, fmtTime(o.createdAt)),
          h("td", {}, o.id === banKho.id ? null : h("button", { type: "button", class: "mini", title: `Cài lại bản v${o.version} xuống bot (dùng khi bản mới hỏng)`, "data-testid": "htb-cai-lai", onclick: () => void pushDialog(o) }, "Cài lại bản này…"))))))));
    }).catch((e) => { if (alive()) { clear(bang); bang.append(h("p", { class: "err small" }, `Không tải được các bản: ${errMsg(e)}`)); } });
  }

  // ---- 5. Tần suất (lịch tự chạy có kịch bản này)
  const theLich = h("div", { class: "card", "data-testid": "htb-lich" }, h("h3", {}, "Tần suất"));
  const dsLich = h("div", {}, h("p", { class: "muted small" }, "Đang tải lịch…"));
  theLich.append(dsLich, h("div", { class: "row" }, h("a", { class: "btn", href: `#/lich?bundle=${encodeURIComponent(ten)}`, title: "Mở trang Lịch chạy với form thêm lịch đã điền sẵn kịch bản này (chưa lưu — bạn chọn bot, giờ rồi bấm Tạo lịch)", "data-testid": "htb-dat-lich" }, "Mở Lịch chạy")));
  root.append(theLich);
  void api<Schedule[]>("GET", "/api/schedules").then((ds) => {
    if (!alive()) return;
    const cua = ds.filter((s) => s.template.bundleName === ten);
    clear(dsLich);
    if (!cua.length) { dsLich.append(h("p", { class: "small muted" }, "Chưa có lịch tự chạy nào cho kịch bản này.")); return; }
    for (const s of cua) dsLich.append(h("p", { class: "small", "data-testid": "htb-lich-dong" }, `${s.hhmm} · ${s.template.mode === "live" ? "chạy thật" : "chạy thử (cũ)"} · ${s.template.botIds.length} bot · ${s.enabled ? "đang bật" : "đang tắt"}`));
  }).catch(() => { if (alive()) { clear(dsLich); dsLich.append(h("p", { class: "small muted" }, "Không tải được lịch.")); } });

  // ---- 6. Viết lại thành sơ đồ bằng AI (tuỳ chọn; tạo kịch bản sơ đồ MỚI, bản học trên bot giữ nguyên)
  const nutViet = h("button", { type: "button", title: "AI viết một kịch bản SƠ ĐỒ mới theo mô tả của kịch bản này; bản học trên bot giữ nguyên", "data-testid": "htb-viet-lai" }, "Viết lại thành sơ đồ bằng AI");
  const loiViet = h("div", { class: "err-box", hidden: true, "data-testid": "htb-viet-loi" });
  const yeuCauId = `yc-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  nutViet.addEventListener("click", () => void busy(nutViet, "Đang gửi…", async () => {
    loiViet.hidden = true;
    const ok = await confirmBox({ title: "Viết lại thành sơ đồ?", text: `AI sẽ viết một kịch bản sơ đồ MỚI theo “${banKho?.description || ten}”. bản học trên bot giữ nguyên.`, okText: "Viết lại" });
    if (!ok || !alive()) return;
    try {
      const d = await api<{ id: string }>("POST", "/api/kich-ban", { yeuCau: (banKho?.description || ten).slice(0, 5000), yeuCauId });
      if (alive()) location.hash = `/kich-ban/${encodeURIComponent(d.id)}`;
    } catch (e) { if (alive()) { loiViet.textContent = errMsg(e); loiViet.hidden = false; } }
  }));
  root.append(h("div", { class: "card", "data-testid": "htb-viet" }, h("h3", {}, "Viết lại thành sơ đồ"),
    h("p", { class: "small muted giai-thich" }, "Không dịch ngược được kịch bản học trên bot thành sơ đồ. AI có thể viết một kịch bản sơ đồ mới làm việc tương tự để bạn sửa từng bước."),
    loiViet, h("div", { class: "row" }, nutViet)));

  return () => khung.cleanup();
}
